import { CTRL_1216 } from './../../../validators/1216/ctrl1216';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step9 } from '../../../../shared/models/component-messages/blocCommun/mapa/step9';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
import { TypeAdresseTEMPOST } from '../../../common/models/type.adresse.tempost';
import { CTRL_1222 } from '../../../validators/1222/ctrl1222';
import { CTRL_TRIM } from '../../../validators/TRIM/ctrlTRIM';
import { MapaINControlNames } from '../../mapa-initial/service/mapaINControleNames';

@Component({
  selector: 'app-type-adresseTEMPOST',
  templateUrl: './type-adresseTEMPOST.component.html'
})
export class TypeAdresseTEMPOSTComponent implements OnInit {
  @Input() uid = '';

  public current_uid = 'TypeAdresseTEMPOST';
  @Input() parentForm: FormGroup;
  @Input() libelle: TypeAdresseTEMPOST;
  @Input() disabled: boolean;

  public siretCtrName: string;
  public rg1 = '_STEP_ID_18_' + CTRL_1222.id + '_1';
  public rg2 = 'CTRL_FACTURATION';
  public rg3 = '_STEP_ID_18_' + CTRL_TRIM.id + '_1';
  public rg4 = '_STEP_ID_18_' + CTRL_1216.id + '_1';

  public step9 = new Step9();
	public optionsSelect: any[];
  public optionsSelectType = 'PAYS';

	constructor(private autoCompleteService: AutoCompleteService) { }

	public ngOnInit() {
		this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);
    this.parentForm.addControl(this.rg1, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_1222Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_facturationNames_json() }));
    this.parentForm.addControl(this.rg3, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_TrimNames_json() }));
    this.parentForm.addControl(this.rg4, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_1222Names_json() }));
    this.siretCtrName = this.getUid() + '_SepAtt_siret';
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
	  return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}

}
